const en = {
  translation: {
    modify: 'Modify',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    add: 'Add',
    logout: 'Logout',
    menus: 'Menus',
    search: 'Search',
    close: 'Close',
    setting: 'Setting',
    error: 'Error',
    select: 'Select',
    cancel: 'Cancel',
    create: 'Create',
    upload: 'Upload',
    update: 'Update',
    sort: 'Sort',
    filter: 'Filter',
    download: 'Download',
    complete: 'Complete',
    query: 'Query',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    applications: 'Applications',
    profile: 'Profile',
    letters: '{{cnt}} letters',
    invite: 'Invite',
    reset: 'Reset',
    male: 'Male',
    female: 'Female',
    tag: 'Tag',
    enabled: 'Enabled',
    disabled: 'Disabled',
    name: 'Name',
    'n-selected': '{{0}} Selected',
    'no-selection': 'No Selection',
    'period.year': '{{years}} Years',
    'period.month': '{{months}} Months',
    'period.day': '{{days}} Days',

    'msg.delete-confirm': 'Are you sure you want to delete?',
    'msg.delete-success': 'Successfully deleted',
    'msg.type-query': 'Please type search query...',

    'common.500.oh': 'Ouch!',
    'common.500.error': 'Unexpeced error occurred',
    'common.500.go-to-home': 'Go to Home',
    'CommonNavigation.search': 'Search',
    'CommonNavigation.menu': 'Menu',
    'CommonSearchResult.empty-result': 'There is no search result',
    'CommonSearchResult.result-num': '{{total}} Results Found',
    'CommonSearchResult.search-status': '{{total}} Results Found for {{query}}',
    'common.form.feedback.required': 'Please input the value',
    'common.form.feedback.no-minus': 'Cannot input minus value',
    'common.select.please-select': 'Please select the value',

    'upload.status': '{{now}} / {{total}} Completed',
    'upload.ready': 'Ready',
    'upload.upload': 'Upload',
    'upload.abort': 'Abort',
    'upload.aborted': 'Aborted',
    'upload.completed': 'Completed',
    'upload.clear': 'Clear',

    'auth.login': 'Login',
    'auth.logout': 'Logout',
    'auth.login-persist': 'Keep Login',
    'auth.register': 'Register',
    'auth.sign-out': 'Withdrawal',
    'auth.sign-out.confirm': 'Are you sure you want to sign-out?',
    'auth.id': 'ID',
    'auth.pw': 'Password',
    'auth.pw-confirm': 'Password Confirm',
    'auth.errMsg.empty-id': 'Please type your ID',
    'auth.errMsg.empty-pw': 'Please type your password',
    'auth.errMsg.short-id': 'ID should be longer than 3 characters',
    'auth.errMsg.long-id': 'ID should be shorter than 21 characters',
    'auth.errMsg.wrong-pattern-id': 'ID should be consist of only alphabet and numbers',
    'auth.errMsg.short-pw': 'Password should be longer than 7 characters',
    'auth.errMsg.long-pw': 'Password should be shorter than 101 charcaters',
    'auth.errMsg.not-equal-pw': 'Password is not equal',
    'auth.errMsg.invalid-id-pw': 'Wrong ID or password',
    'auth.errMsg.already-exist-id': 'Already using ID',
    'auth.errMsg.captcha-required': 'Captcha Required',
    'auth.auth-status.exist-id': 'Already using ID',
    'auth.auth-status.invalid-length-id': 'Id length should be 8 ~ 255',
    'auth.auth-status.invalid-pattern-id': 'ID should be consist of only alphabet and numbers',
    'auth.auth-status.invalid-length-password': 'Password length should be 8 ~ 255',
    'auth.auth-status.wrong-password': 'Wrong Password',
    'auth.auth-status.current-password': 'Same as current password',
    'auth.auth-status.not-exist-user-or-password': 'Wrong ID or password',

    'photo.page.album-detail.title': 'Photo List - {{0}}',
    'AlbumViewerPage.title': 'Album Viewer',
    'PhotoListPage.title': 'My Photo List',
    'PhotoSearchModal.title': 'Search Photo',

    'HyunDutch.nav-trips': 'My trips',
    'HyunDutch.nav-home': 'Home',
    'HyunDutch.nav-records': 'Records',
    'HyunDutch.nav-settle': 'Settle',
    'HyunDutch.nav-mine': 'My spending',
    'HyunDutch.add-record': 'Add record',
    'HyunDutch.switch-trip': 'Switch trip',
    'HyunDutch.trips-empty-title': 'No trips yet',
    'HyunDutch.trips-empty-desc': 'Open an invite link from a friend and the trip will be kept on this device.',
    'HyunDutch.trips-desc': 'Trips you joined with an invite link.',
    'HyunDutch.trip-members': 'Members {{names}}',
    'HyunDutch.select-title': 'Who are you?',
    'HyunDutch.select-desc': 'Pick yourself. This device will remember it.',
    'HyunDutch.select-empty': 'This trip has no members yet',
    'HyunDutch.trip-currency': 'Trip currency',
    'HyunDutch.settle-currency': 'Settle currency',
    'HyunDutch.members': 'Members',
    'HyunDutch.members-count': '{{cnt}}',
    'HyunDutch.status': 'Status',
    'HyunDutch.status-desc': 'Paid minus share. Plus means money to receive, minus means money to pay.',
    'HyunDutch.paid': 'Paid',
    'HyunDutch.share': 'Share',
    'HyunDutch.receive': 'To receive',
    'HyunDutch.owe': 'To pay',
    'HyunDutch.even': 'Even',
    'HyunDutch.no-status': 'No records yet',
    'HyunDutch.no-status-desc': 'Record what you spent on the trip and this shows who receives and who pays.',
    'HyunDutch.records-count': '{{cnt}} records',
    'HyunDutch.search-placeholder': 'Search records or places',
    'HyunDutch.all-currencies': 'All',
    'HyunDutch.no-records': 'No records',
    'HyunDutch.no-records-desc': 'Record what you spent on the trip.',
    'HyunDutch.no-results': 'No matching records',
    'HyunDutch.f-content': 'Description',
    'HyunDutch.f-content-placeholder': 'What was it for?',
    'HyunDutch.f-location': 'Place',
    'HyunDutch.f-currency': 'Currency',
    'HyunDutch.f-payment': 'Payment',
    'HyunDutch.f-date': 'Time',
    'HyunDutch.f-paid': 'Paid by',
    'HyunDutch.f-paid-desc': 'Who actually paid and how much',
    'HyunDutch.f-share': 'Split between',
    'HyunDutch.f-share-desc': 'Who shares this cost and how much',
    'HyunDutch.amount': 'Amount',
    'HyunDutch.select-all': 'All',
    'HyunDutch.split-equally': 'Split equally',
    'HyunDutch.sum-paid': 'Paid total',
    'HyunDutch.sum-share': 'Split total',
    'HyunDutch.invalid-sum': 'The paid total and the split total are not equal',
    'HyunDutch.no-share-members': 'Pick people above',
    'HyunDutch.save': 'Save',
    'HyunDutch.create-title': 'Add record',
    'HyunDutch.update-title': 'Edit record',
    'HyunDutch.total': 'Total',
    'HyunDutch.each-share': 'Each share',
    'HyunDutch.payment-card': 'Card',
    'HyunDutch.payment-cash': 'Cash',
    'HyunDutch.settle-title': 'Settle',
    'HyunDutch.rates': 'Settle rates',
    'HyunDutch.rates-desc': 'Rates used to convert into the settle currency. After changing them, settle again.',
    'HyunDutch.rate-unset': 'Not set',
    'HyunDutch.rate-save': 'Save',
    'HyunDutch.leader': 'Treasurer',
    'HyunDutch.leader-desc': 'Pick who collects the money; we work out who sends how much to whom.',
    'HyunDutch.settle-run': 'Settle',
    'HyunDutch.settle-result': 'Result',
    'HyunDutch.send': 'To pay',
    'HyunDutch.receive-label': 'To receive',
    'HyunDutch.msg-send': '{{name}} pays {{amount}}',
    'HyunDutch.msg-receive': '{{name}} receives {{amount}}',
    'HyunDutch.copy': 'Copy result',
    'HyunDutch.copied': 'Copied',
    'HyunDutch.mine-desc': 'What I spent.',
    'HyunDutch.cash-status': 'Cash',
    'HyunDutch.initial-balance': 'Prepared',
    'HyunDutch.spent-balance': 'Spent',
    'HyunDutch.remaining-balance': 'Left',
    'HyunDutch.edit-balance': 'Edit prepared cash',
    'HyunDutch.balance-desc': 'Enter the cash you prepared before the trip, per currency.',
    'HyunDutch.my-spends': 'My spending',
    'HyunDutch.no-spends': 'No spending yet',
    'HyunDutch.switch-member': 'View as someone else',
    'HyunDutch.balance-title': 'Edit prepared cash',

    'PageSelectModal.title': 'Move Page',
    'PageSelectModal.close': 'Close',
    'PageSelectModal.move': 'Move',
    'PageSelectModal.msg.invalid-page': 'Are you sure you want to cancel the upload?',

    'menu.profile': 'Show Profile',

    'ChatPage.title': 'Chat',
    'ChatPage.new-chat': 'New chat',
    'ChatPage.empty': 'How can I help you?',
    'ChatPage.placeholder': 'Type a message',
    'ChatPage.send': 'Send',
    'ChatPage.stop': 'Stop',
    'ChatPage.thinking': 'Thinking...',
    'ChatPage.thought': 'Thought process',
    'ChatPage.llm-online': 'LLM on',
    'ChatPage.llm-offline': 'LLM off',
    'ChatPage.tokens-context': 'Context',
    'ChatPage.llm-offline-hint': 'The LLM server is off. You can use it once it is back on',
    'ChatPage.llm-unavailable': 'Cannot reach the LLM server. It may be turned off.',
    'ChatPage.attach-image': 'Attach image',
    'ChatPage.remove-image': 'Remove image',
    'ChatPage.model-vision': 'images',
    'ChatPage.model-audio': 'audio',
    'ChatPage.attach-audio': 'Attach audio file',
    'ChatPage.remove-audio': 'Remove audio',
    'ChatPage.mic-start': 'Record with microphone',
    'ChatPage.mic-stop': 'Stop recording and attach',
    'ChatPage.mic-denied': 'Cannot use the microphone. Check the browser microphone permission.',
    'ChatPage.audio-too-long': 'The audio is too long. Keep it under 4 minutes.',
    'ChatPage.audio-failed': 'Cannot read the audio. Try another format.',
    'ChatPage.completed': '{{time}} completed',
    'ChatPage.elapsed': 'took {{duration}}',
    'ChatPage.elapsed-seconds': '{{s}}s',
    'ChatPage.elapsed-minutes': '{{m}}m {{s}}s',
    'HyunGPT.open-sidebar': 'Open sidebar',
    'HyunGPT.close-sidebar': 'Close sidebar',
    'HyunGPT.search-placeholder': 'Search chats',
    'HyunGPT.clear': 'Clear',
    'HyunGPT.loading': 'Loading…',
    'HyunGPT.no-sessions': 'No conversations yet',
    'HyunGPT.searching': 'Searching…',
    'HyunGPT.no-results': 'No results',
    'HyunGPT.result-count': '{{count}} results',
    'HyunGPT.group-today': 'Today',
    'HyunGPT.group-yesterday': 'Yesterday',
    'HyunGPT.group-week': 'Previous 7 days',
    'HyunGPT.group-month': 'Previous 30 days',
    'HyunGPT.group-older': 'Older',
    'HyunGPT.rename': 'Rename',
    'HyunGPT.delete-confirm': 'Delete this conversation? This cannot be undone.',
    'HyunGPT.llm-waking': 'LLM starting',
    'HyunGPT.model-search': 'web search',
    'HyunGPT.tokens-used': 'Used',
    'HyunGPT.tokens-left': 'Left',
    'HyunGPT.tokens-last': 'Last reply',
    'HyunGPT.tokens-in-out': '{{prompt}} in · {{completion}} out',
    'HyunGPT.copy': 'Copy',
    'HyunGPT.copied': 'Copied',
    'HyunGPT.jump-to-bottom': 'Jump to bottom',
    'HyunGPT.suggestion-1': "What's the weather in Seoul today?",
    'HyunGPT.suggestion-2': 'Polish this email to sound polite',
    'HyunGPT.suggestion-3': 'Python code to batch-rename files',
    'HyunGPT.suggestion-4': 'Suggest a weekend getaway nearby',
    'hs.back': 'Back',
    'hs.open-sidebar': 'Open sidebar',
    'hs.close-sidebar': 'Close sidebar',
    'hs.clear': 'Clear',
    'hs.chip-create': 'Add "{{name}}"',
    'hs.switch-service': 'Switch service',
    'hs.services': 'Services',
    'hs.account': 'Account',
    'hs.login': 'Log in',
    'hs.account-sub': 'Hyunsub account',
    'hs.profile': 'Manage profile',
    'hs.theme': 'Theme',
    'hs.theme-light': 'Light',
    'hs.theme-dark': 'Dark',
    'hs.theme-system': 'Device',
    'hs.theme-desc': 'Saved right away and applied to every service.',
    'hs.language': 'Language',
    'hs.language-desc': 'Saved right away and applied to every service.',
    'HyunApps.greeting': 'Hello, {{name}}',
    'HyunApps.greeting-sub': 'Pick a service to open.',
    'HyunApps.recent': 'Recent',
    'HyunApps.all': 'All services',
    'HyunApps.login-title': 'Sign in to continue',
    'HyunApps.login-desc': 'The services you can use appear after you sign in.',
    'HyunApps.login': 'Sign in',
    'HyunApps.empty-title': 'No services available',
    'HyunApps.empty-desc': 'Ask an administrator if you need access.',
    'HyunApps.desc-video': 'Movies and videos',
    'HyunApps.desc-photo': 'Photo library',
    'HyunApps.desc-comic': 'Read comics',
    'HyunApps.desc-apparel': 'Wardrobe and outfits',
    'HyunApps.desc-drive': 'File storage',
    'HyunApps.desc-agnam': 'Agnam',
    'HyunApps.desc-git': 'Code repositories',
    'HyunApps.desc-diary': 'Daily journal',
    'HyunApps.desc-friend': 'People you know',
    'HyunApps.desc-encode': 'Video encoding',
    'HyunApps.desc-archive': 'Saved web pages',
    'HyunApps.desc-timeline': 'Places you went',
    'HyunApps.desc-chat': 'AI chat',
    'HyunApps.desc-dutch': 'Trip expense splitting',
    'hs.menu-title': 'Account & services',
    'hs.menu-tab': 'Menu',
    'hs.today': 'Today',
    'hs.close': 'Close',
    'hs.error': 'Error',
    'hs.not-found-title': "We couldn't find that page",
    'hs.not-found-desc': 'The address may have changed, or the page no longer exists.',
    'hs.forbidden-title': "You don't have access to this page",
    'hs.forbidden-desc': "This account doesn't have permission to view this screen.",
    'hs.switch-account': 'Sign in with another account',
    'hs.crash-title': 'Something went wrong',
    'hs.crash-desc': 'Reloading usually fixes it.',
    'hs.crash-update': 'A new version is available. Please reload.',
    'hs.crash-detail': 'Details',
    'hs.reload': 'Reload',
    'hs.go-home': 'Go home',
    'hs.go-back': 'Go back',
    'hs.format-month': 'LLLL yyyy',
    'hs.n-selected': '{{cnt}} selected',
    'hs.cancel-select': 'Done selecting',
    'HyunPhoto.nav-photos': 'Photos',
    'HyunPhoto.nav-albums': 'Albums',
    'HyunPhoto.nav-downloads': 'Downloads',
    'HyunPhoto.upload': 'Upload',
    'HyunPhoto.upload-subtitle': 'Photos and videos are sorted by date',
    'HyunPhoto.upload-to-album': 'Upload to album',
    'HyunPhoto.n-photos': '{{cnt}} photos',
    'HyunPhoto.select': 'Select',
    'HyunPhoto.filter': 'Filter',
    'HyunPhoto.filter-name': 'File name',
    'HyunPhoto.filter-name-placeholder': 'Text in the name',
    'HyunPhoto.filter-period': 'Period',
    'HyunPhoto.filter-start': 'Start',
    'HyunPhoto.filter-end': 'End',
    'HyunPhoto.filter-tag': 'Tag',
    'HyunPhoto.filter-tag-placeholder': 'Find a tag',
    'HyunPhoto.filter-orphan': 'Only photos not in any album',
    'HyunPhoto.filter-reset': 'Clear filters',
    'HyunPhoto.filter-apply': 'Apply',
    'HyunPhoto.no-match': 'No photos match',
    'HyunPhoto.empty': 'No photos yet',
    'HyunPhoto.empty-desc': 'Uploaded photos are gathered here by date taken.',
    'HyunPhoto.add-to-album': 'Add to album',
    'HyunPhoto.download': 'Download',
    'HyunPhoto.delete': 'Delete',
    'HyunPhoto.delete-confirm': 'Delete {{cnt}} photos? They will also leave their albums.',
    'HyunPhoto.shift-date': 'Shift date',
    'HyunPhoto.shift-date-title': 'Shift the selected photos by the same amount',
    'HyunPhoto.shift-date-hint': 'For fixing a batch with the wrong time zone. Negative moves earlier.',
    'HyunPhoto.shift-later': 'Moves {{amount}} {{unit}} later',
    'HyunPhoto.shift-earlier': 'Moves {{amount}} {{unit}} earlier',
    'HyunPhoto.shift-apply': 'Shift',
    'HyunPhoto.unit-MINUTES': 'min',
    'HyunPhoto.unit-HOURS': 'h',
    'HyunPhoto.unit-DAYS': 'd',
    'HyunPhoto.unit-MONTHS': 'mo',
    'HyunPhoto.unit-YEARS': 'y',
    'HyunPhoto.new-album': 'New album',
    'HyunPhoto.new-album-placeholder': 'New album name',
    'HyunPhoto.create': 'Create',
    'HyunPhoto.album-not-found': 'Album not found',
    'HyunPhoto.album-empty': 'This album is empty',
    'HyunPhoto.album-empty-desc': 'Add photos from your library or upload directly.',
    'HyunPhoto.rename-album': 'Rename',
    'HyunPhoto.share-album': 'Share with friends',
    'HyunPhoto.share-desc': 'Friends can view and add photos. Only the owner can change this.',
    'HyunPhoto.share-placeholder': 'Find friends',
    'HyunPhoto.album-table': 'Table view',
    'HyunPhoto.album-dates': 'Date info',
    'HyunPhoto.delete-album': 'Delete album',
    'HyunPhoto.album-delete-confirm': 'Delete the album "{{name}}"? Photos stay.',
    'HyunPhoto.set-cover': 'Set as cover',
    'HyunPhoto.remove-from-album': 'Remove',
    'HyunPhoto.remove-from-album-confirm': 'Remove {{cnt}} photos from this album? Photos stay.',
    'HyunPhoto.member-all': 'All',
    'HyunPhoto.save': 'Save',
    'HyunPhoto.upload-choose': 'Choose photos and videos',
    'HyunPhoto.upload-hint': 'Click to choose, or drop files or folders',
    'HyunPhoto.upload-files': 'Files',
    'HyunPhoto.upload-size': 'Size',
    'HyunPhoto.upload-remaining': 'Remaining',
    'HyunPhoto.upload-done': 'Done',
    'HyunPhoto.upload-status-ready': 'Ready to upload',
    'HyunPhoto.upload-status-uploading': 'Uploading {{done}}/{{total}}',
    'HyunPhoto.upload-status-success': 'All {{total}} uploaded',
    'HyunPhoto.upload-status-error': '{{failed}} failed',
    'HyunPhoto.upload-status-aborted': 'Stopped',
    'HyunPhoto.upload-clear': 'Clear',
    'HyunPhoto.upload-start': 'Upload {{cnt}}',
    'HyunPhoto.upload-abort': 'Stop',
    'HyunPhoto.upload-more': 'Upload more',
    'HyunPhoto.upload-view': 'View',
    'HyunPhoto.downloads-subtitle': 'Zips of selected photos',
    'HyunPhoto.downloads-empty': 'No downloads yet',
    'HyunPhoto.downloads-empty-desc': 'Select photos and press Download to bundle them here.',
    'HyunPhoto.download-content': '{{content}} and {{total}} photos',
    'HyunPhoto.download-ready': 'Ready',
    'HyunPhoto.download-progress': 'Bundling {{progress}}/{{total}}',
    'HyunPhoto.photo-info': 'Photo info',
    'HyunPhoto.photo-not-found': 'Photo not found',
    'HyunPhoto.view-original': 'View original',
    'HyunPhoto.info-date': 'Taken',
    'HyunPhoto.info-date-type': 'Date source',
    'HyunPhoto.info-file-name': 'File name',
    'HyunPhoto.info-image-size': 'Resolution',
    'HyunPhoto.info-file-size': 'File size',
    'HyunPhoto.info-model': 'Camera',
    'HyunPhoto.info-reg-dt': 'Uploaded',
    'HyunPhoto.info-tags': 'Tags',
    'HyunPhoto.edit-date': 'Edit date',
    'HyunPhoto.tags-placeholder': 'Add tags',
    'HyunPhoto.go-to-detail': 'More details',
    'HyunPhoto.vision': 'AI analysis (beta)',
    'HyunPhoto.vision-caption': 'Caption',
    'HyunPhoto.vision-tagging': 'Classification',
    'HyunPhoto.vision-objects': 'Object detection',
    'HyunPhoto.vision-model': 'Choose a model',
    'hs.previous': 'Previous',
    'hs.next': 'Next',
    'HyunComic.nav-home': 'Home',
    'HyunComic.nav-history': 'Reading history',
    'HyunComic.nav-comics': 'Comics',
    'HyunComic.continue': 'Continue reading',
    'HyunComic.all-comics': 'All comics',
    'HyunComic.see-all': 'See all',
    'HyunComic.n-episodes': '{{cnt}} episodes',
    'HyunComic.n-pages': '{{cnt}} pages',
    'HyunComic.page-of': 'p. {{page}} / {{total}}',
    'HyunComic.episode-page': '{{episode}} · p. {{page}}/{{total}}',
    'HyunComic.episode-done': 'Finished {{episode}}',
    'HyunComic.page-in': '{{episode}} from p. {{page}}',
    'HyunComic.next-up': 'Next',
    'HyunComic.done': 'Read',
    'HyunComic.last-read': 'Last read',
    'HyunComic.read-count': '{{cnt}} read',
    'HyunComic.resume': 'Continue',
    'HyunComic.start': 'Start reading',
    'HyunComic.episodes': 'Episodes',
    'HyunComic.sort-first': 'Oldest',
    'HyunComic.sort-latest': 'Newest',
    'HyunComic.empty-home': 'No comics yet',
    'HyunComic.empty-history': "You haven't read anything yet",
    'HyunComic.not-found': 'Comic not found',
    'HyunComic.episode-not-found': 'Episode not found',
    'HyunComic.reading-mode': 'Reading mode',
    'HyunComic.mode-ltr': 'Left to right',
    'HyunComic.mode-rtl': 'Right to left (manga)',
    'HyunComic.mode-scroll': 'Vertical scroll',
    'HyunComic.prev-episode': 'Previous episode',
    'HyunComic.next-episode': 'Next episode',
    'HyunComic.end-of': 'End of {{episode}}',
    'HyunComic.read-next': 'Read next episode',
    'HyunComic.end-latest': "You're all caught up",
    'HyunComic.episode-list': 'Episodes',

    'HyunVideo.nav-home': 'Home',
    'HyunVideo.nav-search': 'Search',
    'HyunVideo.nav-history': 'History',
    'HyunVideo.nav-categories': 'Categories',
    'HyunVideo.admin': 'Admin',
    'HyunVideo.continue': 'Continue watching',
    'HyunVideo.see-all': 'See all',
    'HyunVideo.n-titles': '{{cnt}} titles',
    'HyunVideo.sort': 'Sort',
    'HyunVideo.sort-random': 'Random',
    'HyunVideo.sort-new': 'Recently added',
    'HyunVideo.sort-old': 'Oldest first',
    'HyunVideo.sort-abc': 'Name A–Z',
    'HyunVideo.sort-zyx': 'Name Z–A',
    'HyunVideo.remaining': '{{time}} left',
    'HyunVideo.duration-hm': '{{h}}h {{m}}m',
    'HyunVideo.duration-m': '{{m}}m',
    'HyunVideo.watched': 'Watched',
    'HyunVideo.episode-n': 'Ep. {{n}}',
    'HyunVideo.episode-special': 'Special',
    'HyunVideo.episodes': 'Episodes',
    'HyunVideo.n-episodes': '{{cnt}} episodes',
    'HyunVideo.now-playing': 'Playing',
    'HyunVideo.play-next': 'Next episode',
    'HyunVideo.more-in-group': 'More in {{name}}',
    'HyunVideo.subtitles': 'Subtitles',
    'HyunVideo.subtitle-size': 'Subtitle size',
    'HyunVideo.subtitle-sync': 'Subtitle sync',
    'HyunVideo.subtitle-sync-hint': 'Shift subtitle timing in milliseconds. Applies to this playback only.',
    'HyunVideo.no-subtitles': 'This video has no subtitles',
    'HyunVideo.manage': 'Manage',
    'HyunVideo.video-manage': 'Manage video',
    'HyunVideo.entry-manage': 'Manage title',
    'HyunVideo.search-placeholder': 'Search by title',
    'HyunVideo.search-hint': 'Find something to watch',
    'HyunVideo.search-empty': 'No titles match "{{query}}"',
    'HyunVideo.empty-home': 'Nothing to watch yet',
    'HyunVideo.list-empty': 'No titles in this category',
    'HyunVideo.no-category': 'Category not found',
    'HyunVideo.not-found': 'Title not found',
    'HyunVideo.history-empty': 'Nothing watched yet',
    'HyunVideo.history-empty-desc': 'Videos you watch show up here so you can pick up where you left off',
    'HyunVideo.select': 'Select',
    'HyunVideo.history-delete': 'Remove',
    'HyunVideo.history-delete-confirm': 'Remove {{cnt}} items from history?',
    'HyunVideo.choose': 'Choose',
    'HyunVideo.none': 'None',
    'HyunVideo.required': 'Required',
    'HyunVideo.output-mp4': 'Path must end with .mp4',
    'HyunVideo.create-entry': 'Create title',
    'HyunVideo.create-entry-desc': 'Creates an empty title (and its folder) and opens its manage page.',
    'HyunVideo.create': 'Create',
    'HyunVideo.register-video': 'Register video',
    'HyunVideo.register-video-desc': 'Moves a source file and registers it as a new title.',
    'HyunVideo.register': 'Register',
    'HyunVideo.register-to-entry': 'Add video to this title',
    'HyunVideo.register-to-entry-desc': 'Moves a source file and adds it to this title.',
    'HyunVideo.field-name': 'Name',
    'HyunVideo.field-category': 'Category',
    'HyunVideo.field-group': 'Group',
    'HyunVideo.field-new-group': 'New group name',
    'HyunVideo.field-thumbnail-url': 'Cover URL',
    'HyunVideo.field-source-path': 'Source path',
    'HyunVideo.field-output-path': 'Destination path (.mp4)',
    'HyunVideo.field-season': 'Season',
    'HyunVideo.field-old-path': 'Current path',
    'HyunVideo.field-new-path': 'New path',
    'HyunVideo.field-from': 'From (regex)',
    'HyunVideo.field-to': 'To',
    'HyunVideo.field-options': 'ffmpeg options',
    'HyunVideo.field-lang': 'Language code',
    'HyunVideo.field-override': 'Overwrite subtitle of the same language',
    'HyunVideo.field-subtitle-file': 'Subtitle file',
    'HyunVideo.field-subtitle-path': 'Subtitle file on server',
    'HyunVideo.scan': 'Rescan folder',
    'HyunVideo.scan-desc': 'Registers new videos and subtitles found in the folder and syncs changed subtitles.',
    'HyunVideo.scan-run': 'Scan',
    'HyunVideo.rename-bulk': 'Bulk rename',
    'HyunVideo.rename-bulk-desc': 'Renames videos, thumbnails and subtitles of this title with a regex.',
    'HyunVideo.rename-run': 'Rename',
    'HyunVideo.move': 'Move folder',
    'HyunVideo.move-desc': 'Moves the title folder to a new path. Try a dry run first.',
    'HyunVideo.dry-run': 'Dry run (do not move)',
    'HyunVideo.move-run': 'Move',
    'HyunVideo.run': 'Run',
    'HyunVideo.save': 'Save',
    'HyunVideo.upload': 'Upload',
    'HyunVideo.metadata': 'Rescan metadata',
    'HyunVideo.metadata-desc': 'Reads duration, resolution, size and bitrate again with ffprobe.',
    'HyunVideo.thumbnail': 'Regenerate thumbnail',
    'HyunVideo.thumbnail-desc': 'Creates the thumbnail again from the video.',
    'HyunVideo.subtitle-upload': 'Add subtitle',
    'HyunVideo.subtitle-upload-desc': 'Upload a subtitle file or move one that is already on the server.',
    'HyunVideo.subtitle-mode-upload': 'Upload file',
    'HyunVideo.subtitle-mode-move': 'Move server file',
    'HyunVideo.subtitle-sync-save': 'Save subtitle sync',
    'HyunVideo.subtitle-sync-save-desc': 'Shifts the subtitle file itself (applies to everyone).',
    'HyunEncode.new': 'New job',
    'HyunEncode.nav-jobs': 'Encoding jobs',
    'HyunEncode.search-placeholder': 'Search by path or options',
    'HyunEncode.no-jobs': 'No encoding jobs',
    'HyunEncode.no-jobs-desc': 'Pick a video file to queue a new job.',
    'HyunEncode.no-results': 'No matching jobs',
    'HyunEncode.running-now': 'Encoding now',
    'HyunEncode.state-waiting': 'Waiting',
    'HyunEncode.state-running': 'Encoding',
    'HyunEncode.state-done': 'Done',
    'HyunEncode.state-failed': 'Failed',
    'HyunEncode.registered': 'Registered {{time}}',
    'HyunEncode.took': 'Took {{time}}',
    'HyunEncode.calculating': 'Calculating…',
    'HyunEncode.remaining': '{{time}} left',
    'HyunEncode.elapsed': 'Elapsed {{time}}',
    'HyunEncode.processed': '{{current}} / {{total}}',
    'HyunEncode.eta': 'ETA {{time}}',
    'HyunEncode.f-id': 'ID',
    'HyunEncode.f-input': 'Input file',
    'HyunEncode.f-output': 'Output file',
    'HyunEncode.f-options': 'Encoding options',
    'HyunEncode.f-callback': 'Callback',
    'HyunEncode.f-reg': 'Registered',
    'HyunEncode.f-start': 'Started',
    'HyunEncode.f-end': 'Finished',
    'HyunEncode.f-took': 'Duration',
    'HyunEncode.start': 'Start',
    'HyunEncode.ffprobe': 'Show source metadata',
    'HyunEncode.input-required': 'Choose an input file',
    'HyunFriend.add': 'Add friend',
    'HyunFriend.new': 'New friend',
    'HyunFriend.edit': 'Edit friend',
    'HyunFriend.save': 'Save',
    'HyunFriend.nav-friends': 'Friends',
    'HyunFriend.nav-tags': 'Tags',
    'HyunFriend.count': '{{cnt}} people',
    'HyunFriend.search-placeholder': 'Search by name',
    'HyunFriend.no-friends': 'No friends yet',
    'HyunFriend.no-friends-desc': 'Keep track of people with a name, tags and notes.',
    'HyunFriend.no-results': 'No results',
    'HyunFriend.f-name': 'Name',
    'HyunFriend.f-birthday': 'Birthday',
    'HyunFriend.f-tags': 'Tags',
    'HyunFriend.f-description': 'Notes',
    'HyunFriend.name-required': 'Enter a name',
    'HyunFriend.birthday-placeholder': 'e.g. 1990-05-21',
    'HyunFriend.tags-placeholder': 'Type a tag and press Enter',
    'HyunFriend.delete-confirm': 'Delete {{name}}? Meeting records are removed too.',
    'HyunFriend.meets': 'Met {{cnt}} times',
    'HyunFriend.unfold': 'Show {{cnt}} more',
    'HyunFriend.fold': 'Show less',
    'HyunFriend.tag-count': '{{cnt}} tags',
    'HyunFriend.tag-search-placeholder': 'Search tags',
    'HyunFriend.no-tags': 'No tags',
    'HyunFriend.no-tags-desc': 'Tags you add to friends show up here.',
    'HyunFriend.friend-count': '{{cnt}} people',
    'HyunFriend.tag-delete-confirm': 'Delete the "{{name}}" tag? Your friends stay.',
    'HyunFriend.rename': 'Rename',
    'HyunArchive.new': 'New archive',
    'HyunArchive.nav-archives': 'Archives',
    'HyunArchive.count': '{{cnt}} items',
    'HyunArchive.search-placeholder': 'Search by title',
    'HyunArchive.no-archives': 'No archives yet',
    'HyunArchive.no-archives-desc': 'Upload a folder of HTML and open it any time.',
    'HyunArchive.no-results': 'No results',
    'HyunArchive.open-new-tab': 'Open in new tab',
    'HyunArchive.delete-confirm': 'Delete the "{{title}}" archive? The uploaded files stay on the file server.',
    'HyunArchive.create': 'Create',
    'HyunArchive.f-title': 'Title',
    'HyunArchive.f-files': 'Folder',
    'HyunArchive.drop-title': 'Choose or drop a folder',
    'HyunArchive.drop-hint': 'A folder with index.html at the top',
    'HyunArchive.file-summary': '{{cnt}} files · {{size}}',
    'HyunArchive.clear': 'Choose again',
    'HyunArchive.no-index': 'There is no index.html at the top, so nothing may show when opened.',
    'HyunArchive.upload-error': 'Failed to upload the files.',
    'HyunAuth.nav-profile': 'Profile',
    'HyunAuth.nav-admin': 'Users',
    'HyunAuth.profile': 'Manage profile',
    'HyunAuth.login-info': 'Sign-in info',
    'HyunAuth.new-username': 'New ID',
    'HyunAuth.old-password': 'Current password',
    'HyunAuth.new-password': 'New password',
    'HyunAuth.new-password-again': 'Confirm new password',
    'HyunAuth.change': 'Change',
    'HyunAuth.relogin-hint': 'You will need to sign in again afterwards.',
    'HyunAuth.login-title': 'Welcome back',
    'HyunAuth.login-desc': 'Sign in with your Hyunsub account',
    'HyunAuth.no-account': "Don't have an account?",
    'HyunAuth.have-account': 'Already have an account?',
    'HyunAuth.register-title': 'Create your account',
    'HyunAuth.register-desc': 'One account for every Hyunsub service',
    'HyunAuth.register-submit': 'Sign up',
    'HyunAuth.id-hint': 'At least 4 letters, numbers or underscores',
    'HyunAuth.pw-hint': 'At least 8 characters',
    'HyunAuth.invalid-url': 'The return address is not valid. Please check the link you received.',
    'HyunAuth.registered': 'Your account is ready. Enter your password to sign in.',
    'HyunAuth.show-password': 'Show password',
    'HyunAuth.hide-password': 'Hide password',
    'HyunAuth.try-again': 'Something went wrong. Please try again in a moment.',
    'HyunAuth.admin-title': 'Users',
    'HyunAuth.admin-count': '{{count}} users',
    'HyunAuth.admin-create': 'New user',
    'HyunAuth.admin-create-submit': 'Create',
    'HyunAuth.admin-name': 'Name (username)',
    'HyunAuth.admin-name-required': 'Enter a name',
    'HyunAuth.admin-search': 'Search by name or ID',
    'HyunAuth.admin-empty': 'No users yet',
    'HyunAuth.admin-no-match': 'No matching users',
    'HyunAuth.admin-user': 'User',
    'HyunAuth.admin-authorities': 'Permissions',
    'HyunAuth.admin-authorities-hint': 'Tap to grant or revoke right away.',
    'HyunAuth.admin-login-as': 'Sign in as this user',
    'HyunAuth.admin-login-as-confirm': 'Sign in as {{name}}? You will be signed out of your current account.',
    'HyunAuth.admin-delete': 'Delete',
    'HyunAuth.admin-delete-confirm': 'Delete {{name}}? This cannot be undone.',
    'HyunVideo.encode': 'Encode',
    'HyunVideo.encode-desc': 'Re-encodes on the file server and rescans metadata when done.',
    'HyunVideo.encode-run': 'Start encoding',
    'HyunVideo.rename': 'Rename file',
    'HyunVideo.rename-desc': 'Replaces part of this video file name.',
    'hs.format-year': '{{year}}',
    'hs.prev-day': 'Previous day',
    'hs.next-day': 'Next day',
    'hs.pick-date': 'Pick a date',
    'hs.prev-month': 'Previous month',
    'hs.next-month': 'Next month',
    'hs.file-choose': 'Choose a file',
    'hs.file-drop-hint': 'Click to choose, or drop it here',
    'hs.file-change': 'click to change',
    'HyunApparel.nav-all': 'All clothes',
    'HyunApparel.nav-categories': 'Categories',
    'HyunApparel.nav-brands': 'Brands',
    'HyunApparel.add': 'Add clothing',
    'HyunApparel.new': 'New clothing',
    'HyunApparel.edit': 'Edit clothing',
    'HyunApparel.save': 'Save',
    'HyunApparel.n-items': '{{cnt}} items',
    'HyunApparel.n-groups': '{{cnt}}',
    'HyunApparel.all': 'All',
    'HyunApparel.empty': 'No clothes yet',
    'HyunApparel.empty-desc': 'Add your clothes with photos and browse them here',
    'HyunApparel.empty-filter': 'No clothes match this filter',
    'HyunApparel.no-categories': 'No categories yet',
    'HyunApparel.no-brands': 'No brands yet',
    'HyunApparel.no-groups-desc': 'They appear automatically as you add clothes',
    'HyunApparel.no-results': 'No results',
    'HyunApparel.search-category': 'Search categories',
    'HyunApparel.search-brand': 'Search brands',
    'HyunApparel.not-found': 'Clothing not found',
    'HyunApparel.discarded': 'Discarded',
    'HyunApparel.mark-discarded': 'Mark as discarded',
    'HyunApparel.unmark-discarded': 'Unmark discarded',
    'HyunApparel.price': '₩{{price}}',
    'HyunApparel.won': 'KRW',
    'HyunApparel.discount-rate': '{{rate}}% off',
    'HyunApparel.sec-photos': 'Photos',
    'HyunApparel.sec-basic': 'Basics',
    'HyunApparel.sec-detail': 'Details',
    'HyunApparel.sec-purchase': 'Purchase',
    'HyunApparel.term-name': 'Name',
    'HyunApparel.term-itemNo': 'Item no.',
    'HyunApparel.term-brand': 'Brand',
    'HyunApparel.term-category': 'Category',
    'HyunApparel.term-size': 'Size',
    'HyunApparel.term-color': 'Color',
    'HyunApparel.term-originPrice': 'List price',
    'HyunApparel.term-discountPrice': 'Paid',
    'HyunApparel.term-buyDt': 'Purchase date',
    'HyunApparel.term-buyLoc': 'Purchased at',
    'HyunApparel.term-material': 'Material',
    'HyunApparel.term-size2': 'Size details',
    'HyunApparel.term-makeDt': 'Made in',
    'HyunApparel.term-discarded': 'Discarded',
    'HyunApparel.discarded-desc': 'Thrown away, but keep the record',
    'HyunApparel.photos-hint':
      'The first photo is the cover. Drag photos to reorder (on a phone, press and hold first).',
    'HyunApparel.name-placeholder': 'e.g. Oversized cotton shirt',
    'HyunApparel.name-required': 'Enter a name',
    'HyunApparel.category-required': 'Enter or choose a category',
    'HyunApparel.create-option': 'Add "{{name}}"',
    'HyunApparel.make-dt-placeholder': 'e.g. 2023-05',
    'HyunApparel.save-failed': "Couldn't save. Please try again.",
    'HyunDrive.nav-files': 'My files',
    'HyunDrive.add': 'Add',
    'HyunDrive.n-items': '{{cnt}} items',
    'HyunDrive.select': 'Select',
    'HyunDrive.sort': 'Sort',
    'HyunDrive.upload-files': 'Upload files',
    'HyunDrive.upload-folder': 'Upload folder',
    'HyunDrive.new-folder': 'New folder',
    'HyunDrive.youtube': 'Get from YouTube',
    'HyunDrive.folder-name': 'Folder name',
    'HyunDrive.create': 'Create',
    'HyunDrive.rename': 'Rename',
    'HyunDrive.name-empty': "Name can't be empty",
    'HyunDrive.name-slash': "Names can't contain /",
    'HyunDrive.name-exists': 'That name already exists',
    'HyunDrive.rename-replace': 'Replace text',
    'HyunDrive.rename-number': 'Add numbers',
    'HyunDrive.rename-pad': 'Pad digits',
    'HyunDrive.rename-reset': 'Reset',
    'HyunDrive.rename-from': 'Text to replace (regex ok)',
    'HyunDrive.rename-to': 'New text',
    'HyunDrive.rename-replace-run': 'Replace',
    'HyunDrive.rename-start': 'Start',
    'HyunDrive.rename-digits': 'Digits',
    'HyunDrive.rename-front': 'Prepend',
    'HyunDrive.rename-back': 'Append',
    'HyunDrive.rename-pad-run': 'Pad',
    'HyunDrive.rename-regex-error': "That pattern isn't valid",
    'HyunDrive.rename-apply': 'Rename {{cnt}}',
    'HyunDrive.remove-confirm': "Delete {{cnt}} selected items? This can't be undone.",
    'HyunDrive.drop-here': 'Drop here to upload',
    'HyunDrive.empty': 'This folder is empty',
    'HyunDrive.empty-desc': 'Drag files here or use Add above',
    'HyunDrive.load-error': "Couldn't load",
    'HyunDrive.col-name': 'Name',
    'HyunDrive.col-size': 'Size',
    'HyunDrive.col-date': 'Modified',
    'HyunDrive.location': 'Location',
    'HyunDrive.sort-name-asc': 'Name (A–Z)',
    'HyunDrive.sort-name-desc': 'Name (Z–A)',
    'HyunDrive.sort-date-desc': 'Modified (newest)',
    'HyunDrive.sort-date-asc': 'Modified (oldest)',
    'HyunDrive.sort-size-desc': 'Size (largest)',
    'HyunDrive.sort-size-asc': 'Size (smallest)',
    'HyunDrive.no-preview': 'No preview for this file',
    'HyunDrive.no-preview-desc': 'Download it to open',
    'HyunDrive.text-truncated': 'Large file — showing the beginning only. Download for the full file.',
    'HyunDrive.youtube-title': 'Get from YouTube',
    'HyunDrive.youtube-error': "Couldn't find that video. Check the URL.",
    'HyunDrive.youtube-resolution': 'Resolution',
    'HyunDrive.youtube-subtitles': 'Subtitles',
    'hs.upload-ready': 'Upload {{cnt}} files?',
    'hs.upload-progress': '{{now}} / {{total}} done',
    'hs.upload-aborted': 'Upload stopped',
    'hs.upload-abort-confirm': 'Stop uploading?',
    'hs.upload-start': 'Upload',
    'hs.upload-abort': 'Stop',
    'hs.cancel': 'Cancel',
    'hs.more': 'More',
    'hs.images-add': 'Add photos',
    'hs.images-cover': 'Cover',
    'hs.remove': 'Remove',

    'HyunTimeline.nav-day': 'Daily route',
    'HyunTimeline.nav-import': 'Import',
    'HyunTimeline.format-day': 'cccc, LLL d',
    'HyunTimeline.format-full': 'ccc, LLL d, yyyy',
    'HyunTimeline.year': '{{year}}',
    'HyunTimeline.day-subtitle': '{{year}} · {{distance}} traveled',
    'HyunTimeline.all-day': 'All day',
    'HyunTimeline.reset-range': 'Show all',
    'HyunTimeline.range-start': 'Start time',
    'HyunTimeline.range-end': 'End time',
    'HyunTimeline.empty-title': 'No records for this day',
    'HyunTimeline.empty-description': 'Locations sent by the app or imported records will be drawn here.',
    'HyunTimeline.flow': 'Your day',
    'HyunTimeline.show-all': 'Show all',
    'HyunTimeline.stat-distance': 'Distance',
    'HyunTimeline.stat-time': 'Recorded',
    'HyunTimeline.stat-count': 'Points',
    'HyunTimeline.speed': 'Speed',
    'HyunTimeline.altitude': 'Altitude',
    'HyunTimeline.accuracy': 'Accuracy',
    'HyunTimeline.open-in-maps': 'Open in Maps',
    'HyunTimeline.stay': 'Stayed {{duration}}',
    'HyunTimeline.move': 'Moved {{distance}}',
    'HyunTimeline.avg-speed': 'avg {{speed}} km/h',
    'HyunTimeline.gap': 'No record · {{duration}}',
    'HyunTimeline.gap-distance': '{{distance}} apart',
    'HyunTimeline.duration-hm': '{{h}}h {{m}}m',
    'HyunTimeline.duration-m': '{{m}}m',
    'HyunTimeline.import-subtitle': 'Bring in a day from Google location history',
    'HyunTimeline.import-step-1': 'Export your Timeline (location history) as JSON from the Google Maps app.',
    'HyunTimeline.import-step-2': "Pick the file and a date — only points you don't have yet are selected.",
    'HyunTimeline.import-step-3': 'Check them on the map, then import to add them to your route.',
    'HyunTimeline.import-file': 'File',
    'HyunTimeline.import-choose-file': 'Choose a JSON file',
    'HyunTimeline.import-date': 'Date to import',
    'HyunTimeline.import-compare': 'Find new points',
    'HyunTimeline.import-new': '{{count}} new points',
    'HyunTimeline.import-parsed': 'Read {{count}} points for this date from the file',
    'HyunTimeline.import-nothing': 'Nothing new to import',
    'HyunTimeline.import-nothing-description': 'Every point for this date is already saved.',
    'HyunTimeline.import-list': 'Show all {{count}} points',
    'HyunTimeline.import-cancel': 'Choose again',
    'HyunTimeline.import-apply': 'Import {{count}}',
    'HyunTimeline.import-done': 'Imported',
    'HyunTimeline.import-done-description': "You can now see it on that day's route.",
    'HyunTimeline.view-day': 'View that day',
    'HyunTimeline.import-another': 'Import another file',
    'HyunDiary.nav-list': 'Journal',
    'HyunDiary.nav-calendar': 'Calendar',
    'HyunDiary.nav-tags': 'Tags',
    'HyunDiary.nav-stats': 'Stats',
    'HyunDiary.write': 'Write',
    'HyunDiary.write-today': "Write today's entry",
    'HyunDiary.write-this-day': 'Write for this day',
    'HyunDiary.edit': 'Edit entry',
    'HyunDiary.save': 'Save',
    'HyunDiary.total-count': '{{cnt}} entries',
    'HyunDiary.result-count': '{{cnt}} results',
    'HyunDiary.month-count': '{{cnt}} this month',
    'HyunDiary.entry-count': '{{cnt}} entries',
    'HyunDiary.tag-count': '{{cnt}} tags',
    'HyunDiary.letters': '{{cnt}} chars',
    'HyunDiary.search-placeholder': 'Search entries',
    'HyunDiary.tag-search-placeholder': 'Search tags',
    'HyunDiary.no-results': 'No matching entries',
    'HyunDiary.empty': 'No entries yet',
    'HyunDiary.empty-desc': 'Write down something about today, even a line.',
    'HyunDiary.no-diary': 'No entry for this day',
    'HyunDiary.no-tags': 'No tags yet',
    'HyunDiary.no-tags-desc': 'Tags you add while writing will show up here.',
    'HyunDiary.no-photos': 'No photos from this day',
    'HyunDiary.today-question': 'How was your day?',
    'HyunDiary.view-calendar': 'View in calendar',
    'HyunDiary.view-all': 'View all',
    'HyunDiary.read-more': 'Read full entry',
    'HyunDiary.photos': '{{cnt}} photos',
    'HyunDiary.timeline': 'Places that day',
    'HyunDiary.open-timeline': 'Open in HyunTimeline',
    'HyunDiary.delete-confirm': 'Delete this entry? This cannot be undone.',
    'HyunDiary.tag-delete-confirm': 'Delete #{{name}}? It will be removed from entries too.',
    'HyunDiary.rename': 'Rename',
    'HyunDiary.summary-placeholder': 'Today in one line',
    'HyunDiary.friends-placeholder': 'People you met',
    'HyunDiary.tags-placeholder': 'Tags',
    'HyunDiary.content-placeholder': 'Write about your day',
    'HyunDiary.draft-saved': 'Draft saved',
    'HyunDiary.overwrite-notice': 'This day already has an entry. Saving will replace it.',
    'HyunDiary.edit-existing': 'Edit existing',
    'HyunDiary.stats-total': 'Entries',
    'HyunDiary.stats-unit-entry': '',
    'HyunDiary.stats-period': 'Writing for',
    'HyunDiary.stats-coverage': 'Coverage',
    'HyunDiary.stats-coverage-hint': 'Days written out of {{days}}',
    'HyunDiary.stats-average': 'Average length',
    'HyunDiary.stats-unit-letter': 'chars',
    'HyunDiary.stats-total-letters': '{{cnt}} chars in total',
    'HyunDiary.stats-distribution': 'Length distribution',
    'HyunDiary.stats-longest': 'Longest entries',
    'HyunDiary.stats-bucket': '~{{range}} chars · {{cnt}} entries',
    'HyunDiary.format-full': 'cccc, LLLL d, yyyy',
    'HyunDiary.format-short': 'ccc, LLL d, yyyy',
    'HyunDiary.format-date': 'LLL d, yyyy',
    'ChatPage.searching': 'Searching',
    'ChatPage.searched': 'Searched',
    'ChatPage.sources': 'Sources',
  },
};

export default en;
